// extracted by mini-css-extract-plugin
export default {"planTypeList":"PlustekEnergyPlan_planTypeList__rB0dC"};